var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useSelector } from 'react-redux';
import { Text, Colors, Inset, Spacing, Icon } from '@doordash/design-language';
import ListCell from '@doordash/component-list-cell';
import styled from 'styled-components';
import Button from '@doordash/component-button';
import OnboardingPageStrings from './OnboardingStrings';
import { useMediaQuery } from '../../Common/MediaQueryProvider';
import { ChecklistTestIds } from './testIds';
import { PORTAL_ROUTE_PREFIX } from '../../../constants/values';
import { getSelectedTeamAccount } from '../../../selectors/uiSelector';
import { useHistory } from 'react-router-dom';
var CHECKLIST_CONTAINER_MIN_WIDTH = '300px';
var CHECKLIST_CONTAINER_MIN_WIDTH_MOBILE = '100%';
export var ChecklistContainer = styled(Inset).attrs(function (props) { return ({
    size: Inset.Sizes.Medium,
    isStretched: props.isMobile ? true : false,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  min-width: ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  box-shadow: 0px ", "px ", "px rgba(0, 0, 0, 0.08);\n  border-radius: ", "px;\n"], ["\n  background-color: ", ";\n  min-width: ",
    ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  box-shadow: 0px ", "px ", "px rgba(0, 0, 0, 0.08);\n  border-radius: ", "px;\n"])), Colors.SystemWhite, function (props) {
    return props.isMobile
        ? CHECKLIST_CONTAINER_MIN_WIDTH_MOBILE
        : CHECKLIST_CONTAINER_MIN_WIDTH;
}, Spacing.XxxSmall, Spacing.Medium, Spacing.XxxSmall);
export var CtaButtonContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  max-width: 120px;\n  margin-top: ", "px;\n"], ["\n  max-width: 120px;\n  margin-top: ", "px;\n"])), Spacing.Medium);
export var Cell = function (_a) {
    var props = __rest(_a, []);
    return (React.createElement(ListCell, __assign({ size: ListCell.Sizes.Small, titleMaxLines: props.isMobile ? 3 : 2, subtextMaxLines: props.isMobile ? 6 : 3, isToggleable: false, isSeparatorVisible: false, insetVerticalSize: ListCell.InsetSizes.Small }, props)));
};
var findNextToDo = function (item) {
    return !item.isCompleted;
};
var getListIconStyle = function (item, isNextToDo, displayNum) {
    if (item.isCompleted) {
        return 'CheckCircleFill';
    }
    return isNextToDo ? "Number" + displayNum + "Fill" : "Number" + displayNum + "Line";
};
var Checklist = function (_a) {
    var checklistItems = _a.checklistItems;
    var isMobile = useMediaQuery().isMobile;
    var teamAccountId = useSelector(getSelectedTeamAccount);
    var nextToDoItemIdx = checklistItems.findIndex(findNextToDo);
    var history = useHistory();
    return (React.createElement(ChecklistContainer, { role: "list", isMobile: isMobile }, checklistItems.map(function (listItem, index) {
        var isNextToDo = nextToDoItemIdx === index;
        var title = listItem.title;
        var listItemDisplayNum = index + 1;
        var textColor = isNextToDo
            ? Text.Colors.SystemGrey100
            : Text.Colors.SystemGrey60;
        var iconTypeName = getListIconStyle(listItem, isNextToDo, listItemDisplayNum);
        var iconColor = isNextToDo
            ? Icon.Colors.SystemRed60
            : Icon.Colors.SystemGrey60;
        var subpage = listItem.toSubpage;
        var redirectPath = PORTAL_ROUTE_PREFIX + "/admin/" + teamAccountId + "/" + subpage;
        return (React.createElement(Cell, { key: listItem.key + "-" + index, "data-testid": ChecklistTestIds["step-" + listItem.key], accessibilityLabel: title, isMobile: isMobile, title: React.createElement(Text, { styles: Text.Styles.Body1Emphasis, color: textColor, "data-testid": ChecklistTestIds.checklistItemTitle }, title), subtext: React.createElement(Text, { styles: Text.Styles.Body2, color: textColor, "data-testid": ChecklistTestIds.checklistItemSubtext }, listItem.subtext), iconStart: {
                type: Icon.Types[iconTypeName],
                color: iconColor,
            }, renderBelowContent: function () {
                if (isNextToDo) {
                    return (React.createElement(CtaButtonContainer, null,
                        React.createElement(Button, { size: Button.Sizes.Small, "data-testid": ChecklistTestIds.getStartedButton, onClick: function () { return history.push(redirectPath); } }, OnboardingPageStrings.checklistActionButton())));
                }
                return null;
            } }));
    })));
};
export default Checklist;
var templateObject_1, templateObject_2;
